<template>
	<div class="collapse margin-left">
		<el-collapse v-model="activeNames" accordion @change="handleChange">
			<el-collapse-item :name="item.id" v-for="(item,index) in list" :key="index">
				<template slot="title">
					<img class="block-28" src="../../../assets/img/feed1.png">
					<span class="text-df margin-left-xs">{{item.title}}</span>
				</template>
				<div v-for="(item2,key) in twolist" :key="key" class="text-sm text-left text-666 pointer" @click="godetail('feedetail',item2)">{{item2.title}}</div>
			</el-collapse-item>
		</el-collapse>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	export default {
		data() {
			return {
				activeNames: ['1'],
				list: [],
				twolist:[],
			};
		},
		created() {
			this.gettype()
		},
		methods: {
			handleChange(val) {
				console.log(val);
				this.getlist(val)
			},
			/**
			 * 获取分类
			 * */
			gettype(){
				this.ajax('get', '/api/feedback/getCateList',{},res => {
					if(res.status == 200){
						this.list = res.data
					}else{
						
					}
				})
			},
			getlist(id){
				this.ajax('get', '/api/feedback/getInfoList',{
					cate_id:id
				},res => {
					if(res.status == 200){
						this.twolist = res.data
					}else{
						
					}
				})
			},
			//通知center 跳转对应页面
			godetail(index,item2){
				let type = {
					type:index,
					typeone:'feedback'
				}
				this.$emit('gettype',type)
				setTimeout(()=>{
					Bus.$emit('feedbackdetail',item2)
				},500)
			}
		}
	}
</script>

<style>
	.collapse{
		width: 920px;
	}
	.el-collapse-item{
		padding: 20px 34px;
		background: #fff;
		margin-bottom: 20px;
		box-shadow: 0px 2px 51px 0px rgba(34,34,34,0.0800);
		border-radius: 8px;
	}
	.el-collapse-item__header,.el-collapse-item__wrap{
		border-bottom: 0 !important;
	}
	.block-28{
		width: 28px;
		height: 28px;
	}
</style>



// WEBPACK FOOTER //
// src/components/my/feed/feedback.vue